import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
	faAddressBook,
	faAddressCard,
	faAngleDown,
	faAngleLeft,
	faAngleRight,
	faAngleUp,
	faAnglesLeft,
	faAnglesRight,
	faArrowDown,
	faArrowLeft,
	faArrowRight,
	faArrowRightFromBracket,
	faArrowRightToBracket,
	faArrowRotateRight,
	faArrowUp,
	faArrowUpRightFromSquare,
	faArrowsLeftRight,
	faBan,
	faBars,
	faBolt,
	faBook,
	faBoxOpen,
	faBug,
	faBuilding,
	faBuildingColumns,
	faBullhorn,
	faCalendar,
	faCalendarCheck,
	faCalendarDay,
	faCalendarDays,
	faCalendarPlus,
	faCalendarWeek,
	faCamera,
	faCameraRotate,
	faCaretDown,
	faCartShopping,
	faChartColumn,
	faChartLine,
	faCheck,
	faChevronDown,
	faChevronLeft,
	faChevronRight,
	faChevronUp,
	faCircle,
	faCircleCheck,
	faCircleExclamation,
	faCircleInfo,
	faCircleMinus,
	faCircleNotch,
	faCirclePlus,
	faCircleQuestion,
	faCircleXmark,
	faClipboardList,
	faClock,
	faClockRotateLeft,
	faCloudArrowUp,
	faComment,
	faCompress,
	faCopy,
	faCreditCard,
	faCrosshairs,
	faDiagramProject,
	faDollarSign,
	faDownload,
	faEllipsis,
	faEllipsisVertical,
	faEraser,
	faLockOpen,
	faSquareCheck,
	faEnvelope,
	faEnvelopeOpen,
	faEnvelopeOpenText,
	faEnvelopesBulk,
	faExpand,
	faEye,
	faEyeSlash,
	faFile,
	faFileArrowDown,
	faFileCircleCheck,
	faFileExcel,
	faFileExport,
	faFileImage,
	faFileInvoiceDollar,
	faFileLines,
	faFilePdf,
	faFilePen,
	faFileWord,
	faFilter,
	faFilterCircleXmark,
	faFlag,
	faFloppyDisk,
	faFolderMinus,
	faFolderOpen,
	faFolder,
	faFutbol,
	faGear,
	faGears,
	faHand,
	faHandshake,
	faHeadset,
	faHouse,
	faImage,
	faInbox,
	faKey,
	faLayerGroup,
	faLightbulb,
	faLink,
	faList,
	faListOl,
	faLocationCrosshairs,
	faLocationDot,
	faLock,
	faMagnifyingGlass,
	faMapLocationDot,
	faMapPin,
	faMedal,
	faMobileScreen,
	faMinus,
	faMoneyBill,
	faMoneyBillWave,
	faPalette,
	faPaperPlane,
	faPenToSquare,
	faPencil,
	faPeopleGroup,
	faPersonCirclePlus,
	faPersonWalkingArrowRight,
	faPlus,
	faRefresh,
	faRightFromBracket,
	faRotate,
	faRotateLeft,
	faRotateRight,
	faShieldHalved,
	faSitemap,
	faSliders,
	faSort,
	faSortDown,
	faSortUp,
	faSpinner,
	faStar,
	faTag,
	faTags,
	faTable,
	faTableCellsLarge,
	faTerminal,
	faTicket,
	faToggleOff,
	faToggleOn,
	faTrash,
	faTrashCan,
	faTriangleExclamation,
	faUpload,
	faUpRightFromSquare,
	faUser,
	faUserCheck,
	faUserClock,
	faUserPen,
	faUserPlus,
	faUserSecret,
	faUserTie,
	faUsers,
	faWallet,
	faX,
	faXmark,
	faStopwatch,
	faMoon,
	faSun
} from '@fortawesome/free-solid-svg-icons';
import { faCircle as faCircleRegular, faClock as faClockRegular, faCopy as faCopyRegular, faEnvelope as faEnvelopeRegular, faFolderOpen as faFolderOpenRegular } from '@fortawesome/free-regular-svg-icons';

const fontAwesomeIcons = [
	faAddressBook,
	faAddressCard,
	faAngleDown,
	faAngleLeft,
	faAngleRight,
	faAngleUp,
	faAnglesLeft,
	faAnglesRight,
	faArrowDown,
	faArrowLeft,
	faArrowRight,
	faArrowRightFromBracket,
	faArrowRightToBracket,
	faArrowRotateRight,
	faArrowUp,
	faArrowUpRightFromSquare,
	faArrowsLeftRight,
	faBan,
	faBars,
	faBolt,
	faBook,
	faBoxOpen,
	faBug,
	faBuilding,
	faBuildingColumns,
	faBullhorn,
	faCalendar,
	faCalendarCheck,
	faCalendarDay,
	faCalendarDays,
	faCalendarPlus,
	faCalendarWeek,
	faCamera,
	faCameraRotate,
	faCaretDown,
	faCartShopping,
	faChartColumn,
	faChartLine,
	faCheck,
	faChevronDown,
	faChevronLeft,
	faChevronRight,
	faChevronUp,
	faCircle,
	faCircleCheck,
	faCircleExclamation,
	faCircleInfo,
	faCircleMinus,
	faCircleNotch,
	faCirclePlus,
	faCircleQuestion,
	faCircleXmark,
	faClipboardList,
	faClock,
	faClockRotateLeft,
	faCloudArrowUp,
	faComment,
	faCompress,
	faCopy,
	faCreditCard,
	faCrosshairs,
	faDiagramProject,
	faDollarSign,
	faDownload,
	faEllipsis,
	faEllipsisVertical,
	faEraser,
	faLockOpen,
	faSquareCheck,
	faEnvelope,
	faEnvelopeOpen,
	faEnvelopeOpenText,
	faEnvelopesBulk,
	faExpand,
	faEye,
	faEyeSlash,
	faFile,
	faFileArrowDown,
	faFileCircleCheck,
	faFileExcel,
	faFileExport,
	faFileImage,
	faFileInvoiceDollar,
	faFileLines,
	faFilePdf,
	faFilePen,
	faFileWord,
	faFilter,
	faFilterCircleXmark,
	faFlag,
	faFloppyDisk,
	faFolderMinus,
	faFolderOpen,
	faFolder,
	faFutbol,
	faGear,
	faGears,
	faHand,
	faHandshake,
	faHeadset,
	faHouse,
	faImage,
	faInbox,
	faKey,
	faLayerGroup,
	faLightbulb,
	faLink,
	faList,
	faListOl,
	faLocationCrosshairs,
	faLocationDot,
	faLock,
	faMagnifyingGlass,
	faMapLocationDot,
	faMapPin,
	faMedal,
	faMobileScreen,
	faMinus,
	faMoneyBill,
	faMoneyBillWave,
	faPalette,
	faPaperPlane,
	faPenToSquare,
	faPencil,
	faPeopleGroup,
	faPersonCirclePlus,
	faPersonWalkingArrowRight,
	faPlus,
	faRefresh,
	faRightFromBracket,
	faRotate,
	faRotateLeft,
	faRotateRight,
	faShieldHalved,
	faSitemap,
	faSliders,
	faSort,
	faSortDown,
	faSortUp,
	faSpinner,
	faStar,
	faStopwatch,
	faMoon,
	faSun,
	faTag,
	faTags,
	faTable,
	faTableCellsLarge,
	faTerminal,
	faTicket,
	faToggleOff,
	faToggleOn,
	faTrash,
	faTrashCan,
	faTriangleExclamation,
	faUpload,
	faUpRightFromSquare,
	faUser,
	faUserCheck,
	faUserClock,
	faUserPen,
	faUserPlus,
	faUserSecret,
	faUserTie,
	faUsers,
	faWallet,
	faX,
	faXmark,
	faCircleRegular,
	faClockRegular,
	faCopyRegular,
	faEnvelopeRegular,
	faFolderOpenRegular
];

export function registerFontAwesome(app) {
	library.add(...fontAwesomeIcons);
	app.component('font-awesome-icon', FontAwesomeIcon);
}
